import { useEffect, useRef, useState } from "react";

export const useElementIsLoaded = (threshold: number) => {
  const elementRef = useRef<HTMLDivElement>(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsLoaded(true);
          observer.unobserve(element);
        }
      },
      { root: null, rootMargin: "0px", threshold },
    );
    observer.observe(element);
    return () => {
      observer.unobserve(element);
    };
  }, [threshold]);

  return { isLoaded, elementRef };
};
